var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoNoImage = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.995,
    height: 31.995,
    viewBox: "0 0 31.995 31.995",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_no_image",
    d: "M1046.694,560.543h-3.21V583.01a3.209,3.209,0,0,0,3.208,3.21h22.474v-3.21h-22.472Zm25.575-6.318h-19.257a3.209,3.209,0,0,0-3.21,3.208V576.7a3.209,3.209,0,0,0,3.208,3.21h19.259a3.209,3.209,0,0,0,3.21-3.208V557.435a3.209,3.209,0,0,0-3.208-3.21ZM1053.012,576.7l4.815-6.42,3.258,4.35,4.767-5.955,6.42,8.026Z",
    transform: "translate(-1043.484 -554.225)",
    fill: "#ccc"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoNoImage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_no_image.da5495060bd01f99c7010bbe59fcf70e.svg";